/* eslint-disable class-methods-use-this */
import { APIService } from './ApiService';
import { APIDocumentsService } from './ApiDocumentsService';

class Service {
  public createDocumment(body: any) {
    const apiPath = '/document';
    const response = APIDocumentsService.post(apiPath, body);
    return response;
  }

  public getDocumentById(id: string) {
    const apiPath = `/document/${id}`;
    const response = APIService.get(apiPath);
    return response;
  }

  public updateDocument(body: object, id: string) {
    const apiPath = `/document/${id}`;
    const response = APIService.put(apiPath, body);
    return response;
  }

  public deleteById(id: string) {
    const apiPath = `/document/${id}`;
    const response = APIService.delete(apiPath);
    return response;
  }
}

// eslint-disable-next-line import/prefer-default-export
export const DocumentsService = new Service();
